module.exports = __webpack_public_path__ + "4722c7354a83777186ffa41593bb821d.fbx";